import React from 'react';
import { ICircularProgressBar } from './CircularProgressBar.interface';
import styles from './CircularProgressBar.module.scss';

export const CircularProgressBar: React.FC<ICircularProgressBar> = ({
  progress
}) => {
  const size = 80;
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 103) * circumference;

  return (
    <div className={styles.container}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className={styles['circular-progress-bar']}
      >
        <circle
          className={styles.background}
          stroke="#CFE1F2"
          strokeWidth={`${strokeWidth}`}
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
        />
        <circle
          className={styles.progress}
          stroke="#06BCFF"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
        />
        <text x="50%" y="50%" textAnchor="middle" dy=".3em">
          {progress.toFixed(1)}%
        </text>
      </svg>
    </div>
  );
};
